/**
 * 画面が使う機能が OFF のときの案内（2026-09-27 dashboard-review）。
 *
 * WHY: 機能はすべて既定 OFF（task/toggles）。以前はランキングやマルチプレイの画面を開いても「まだ何もありません」だけで、
 *   そもそも機能が OFF だから何も起きない、と気づけなかった（ゲームから呼んでも 403 feature_disabled）。
 *   OFF のものだけを並べ、手元で ON にするコマンドと、概要の「機能」（確認つきでその場で切り替えられる）への道を出す。
 * 一覧は GET …/features（FeaturesCard と同じ）。取れない・全部 ON なら何も出さない（案内のために画面を壊さない）。
 * 最初の公開で見せない機能（launchHidden.ts）は案内しない（ON にするコマンドを出すと、隠した機能の入口になる）。
 */
import { Link } from 'react-router-dom';
import { envPath, type FeaturesView } from '../api';
import { enableCommands } from '../featureToggle';
import { useResource } from '../hooks';
import { isLaunchHidden } from '../launchHidden';
import { useT } from '../i18n';
import { CodeBlock } from './ui';

export function FeatureHint({ projectId, env, need }: { projectId: string; env: 'development' | 'production'; need: string[] }) {
  const r = useResource<FeaturesView>(`${envPath(projectId, env)}/features`);
  const { t, tr } = useT();
  const off = need.filter((k) => !isLaunchHidden(k) && r.data?.features.find((f) => f.key === k)?.enabled === false);
  if (!off.length) return null;
  return (
    <div className="alert alert-info feature-hint" role="note">
      <strong>{t('featureHint.title', { names: off.join(', '), env: t(`env.inline.${env}`) })}</strong>
      <span>{tr('featureHint.body', { link: <Link to="../overview">{t('featureHint.link')}</Link> })}</span>
      <CodeBlock code={enableCommands(off, env)} />
    </div>
  );
}
